<template>
  <div class="c-material-lifecycle">
    <div class="c-form">
      <ElForm inline label-width="50px" @submit.native.prevent class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="游戏组">
          <el-select
            v-model="gameGroups"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="全部"
            value-key="id"
            @change="onGameGroupChange"
          >
            <el-option v-for="item in GAME_GROUPS" :key="item.id" :label="item.name" :value="item"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="标签">
          <el-select
            v-model="labelIds"
            multiple
            :multiple-limit="100"
            :popper-append-to-body="false"
            filterable
            collapse-tags
            clearable
            placeholder="请选择标签"
            style="width: 180px"
            @change="setLabelIds"
          >
            <el-option v-for="item in sysTagList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="标签组">
          <el-select v-model="tagGroups" filterable clearable multiple collapse-tags style="width: 160px" placeholder="全部">
            <el-option v-for="item in SYS_TAG_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="媒体">
          <el-select v-model="mediaId" clearable placeholder="全部" style="width: 160px">
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="统计时间" label-width="70px">
          <DateRangePicker v-model="datetime" :clearable="false" @change="handleDatetime" style="width: 220px"> </DateRangePicker>
        </ElFormItem>
        <ElFormItem label="统计方式" label-width="70px">
          <el-radio-group class="summary-type-radio" v-model="queryType" @change="onQueryTypeChange">
            <el-radio-button :label="1">分日</el-radio-button>
            <el-radio-button :label="2">汇总</el-radio-button>
          </el-radio-group>
        </ElFormItem>
        <ElFormItem label-width="0" class="bg-transparent">
          <ElButton type="primary" @click="getData">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
    <div class="c-m-table">
      <Tabs v-model="platform" class="c-table-list">
        <TabPane name="0" label="全部"></TabPane>
        <TabPane name="1" label="Andriod"></TabPane>
        <TabPane name="2" label="iOS"></TabPane>
        <template slot="extra">
          <Button @click="modalColumn = true">自定义列</Button>
          &ensp;
          <Button :disabled="!tableList.length" icon="md-download" style="margin-right: 2px" @click="downData">数据导出</Button>
        </template>
      </Tabs>

      <div class="c-compare-wrap">
        <template v-if="tableList.length">
          <div class="c-compare-form">
            <Select v-model="referEc" style="width: 180px">
              <Option v-for="drop in referEcDrop" :key="drop.key" :value="drop.key">{{ drop.title }}</Option>
            </Select>
          </div>
          <div class="c-echarts">
            <compare-echart :loading="loading" :compare-options="echartsOptions" />
          </div>
        </template>
        <Spin size="large" fix v-else-if="loading" />
        <div class="no-data" v-else>
          <Icon type="ios-filing-outline" size="58" color="#efefef" />
          <span>暂未选择标签</span>
        </div>
      </div>
      <Viewport v-if="tableListLoaded" v-model="tableHeight">
        <lifecycle-table
          :loading="loading"
          :height="tableHeight - 32"
          :data="tableList"
          :columns="tableCol"
          :summary="summaries"
          :query-type="queryType"
          @on-sort="sortTable"
        />
        <Page
          show-total
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          show-sizer
          :page-size="pageSize"
          :page-size-opts="[15, 30, 50, 100]"
          @on-change="changePIndex"
          @on-page-size-change="changeSize"
        />
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" :sub-title="['报表数据', '创角留存', '创角LTV']" @on-select="selectColumn" />
  </div>
</template>
<script>
import moment from 'moment'
import { getLocal, setLocal, mul } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { toThousands, toPercentFixed, datetimeToDay } from '@/common/js/filters'
import { HOST_API } from '@/api/config'

import mixinTable from './mixin_table'
import columns from '../data/material_label_life_column'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import CustomColumn from '@/components/converter/custom-column.vue'
import CompareEchart from '@/components/echarts/echart.vue'
import LifecycleTable from './components/lifecycle-table'

import { getLabelLifeCycle } from '@/api/report.model'
import { initPageData, GAME_GROUPS, MEDIAS, SYS_TAGS, SYS_TAG_GROUPS } from '@/data/global-opts'

// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, MEDIAS, SYS_TAGS, SYS_TAG_GROUPS])

export default {
  name: 'labellifecycle',
  mixins: [mixinTable],
  components: { CustomColumn, LifecycleTable, DateRangePicker, CompareEchart },
  computed: {
    ...PAGE_REQUIRED_OPTS,

    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    },
    referEcDrop() {
      return this.dropData.filter((ret) => ret.key)
    },
    /**
     * @description: 根据游戏组过滤标签
     */
    sysTagList() {
      if (!this.gameGroups?.length) return this.SYS_TAGS

      // 如果选择了游戏组，过滤掉不属于游戏组的标签
      const data = this.SYS_TAGS.filter((tag) => {
        if (!tag.gameIds) return false
        return this.selectedGameIds.some((id) => tag.gameIds.includes(id))
      })
      return data
    }
  },
  methods: {
    getData() {
      const [beginTime, endTime] = this.datetime || []
      const param = {
        platform: this.platform,
        labelIds: this.labelIds,
        beginTime,
        endTime,
        mediaId: this.mediaId,
        queryType: this.queryType,
        labelGroupList: this.tagGroups,
        sort: this.sort,
        order: this.order
      }
      this.loading = true
      getLabelLifeCycle(param).then((data) => {
        this.loading = false
        if (!data) return
        const { list, sumData } = data
        if (isArray(list) && sumData) {
          // 分日统计方式时，不显示新增关联素材数、总关联素材数
          if (this.queryType === 1) {
            this.sumData = { ...sumData, relatedMaterialsTotal: '-' }
          } else {
            this.sumData = sumData
          }
          this.listData = list
          this.tableList = this.calcTableData()
          this.total = list.length
          this.tableListLoaded = true
          this.creatEchart(this.referEc)
        }
      })
    },
    /**
     * @description: 切换游戏组时，根据游戏组筛选标签
     */
    onGameGroupChange(g) {
      this.labelIds = []
      this.selectedGameIds = g
        .map((item) => item.gameIds)
        .reduce((acc, curr) => {
          return acc.concat(curr)
        }, [])
    },
    onQueryTypeChange() {
      this.pageIndex = 1
    },
    calcTableData() {
      const start = (this.pageIndex - 1) * this.pageSize
      const end = this.pageSize * this.pageIndex
      return this.listData.slice(start, end)
    },
    creatEchart(refer, compare) {
      const ecKeys = [refer]
      const tableList = JSON.parse(JSON.stringify(this.listData))
      const legends = Array.from(new Set(tableList.map((ret) => ret.labelName)))

      // 如果queryType = 2 汇总统计，x轴只取一个点，就是统计的时间段，tableList[0].tdateDesc
      const xAxisData =
        this.queryType === 1
          ? Array.from(new Set(tableList.map((ret) => datetimeToDay(ret.tdate)))).sort((a, b) => Date.parse(a) - Date.parse(b))
          : [tableList[0].tdateDesc]

      const yAxis = ecKeys.map((ret, i) => {
        const column = columns.filter((t) => t.key === ret).pop()
        let unit = ''
        if (ret.includes('Rate')) unit = '%'
        else if (['paperUseAmount', 'amount', 'activeCost', 'createRoleCost', 'sumRecharge', 'sumMoney'].includes(ret)) unit = '元'
        return {
          name: column.title,
          nameGap: 5,
          type: 'value',
          axisLabel: {
            formatter: `{value} ${unit}`
          }
        }
      })
      const series = legends.map((met) => {
        return {
          name: met,
          data: tableList
            .filter((ret) => ret.labelName === met)
            .sort((a, b) => a.tdate - b.tdate)
            .map((ret) => (refer.includes('Rate') ? mul(100, ret[refer]) : ret[refer])),
          type: 'line'
        }
      })

      // 图表配置
      this.echartsOptions = {
        legend: {
          height: 30,
          bottom: 0,
          itemWidth: 12,
          itemHeight: 6,
          align: 'right',
          data: legends,
          textStyle: {
            lineHeight: 4
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          padding: 10,
          confine: true,
          formatter: (params) => {
            let total = 0
            legends.map((ret, i) => {
              total += params[i].value
            })
            const tooltips = legends.map((ret, i) => {
              let unit = ''
              let percent = 0
              if (total) {
                let val = params[i].value / total
                if (val > 0 && val < 1) {
                  const t = val.toString().split('.')
                  if (t[1] && t[1].length > 4) val = parseFloat(val.toFixed(4))
                }
                percent = mul(val, 100)
              }
              if (refer.includes('Rate')) unit = '%'
              else if (['paperUseAmount', 'amount', 'activeCost', 'createRoleCost', 'sumRecharge', 'sumMoney'].includes(refer)) unit = '元'
              const percentShow = ['paperUseAmount', 'amount', 'downNum', 'newUserNum', 'createRoleNum', 'newRoleNum'].includes(refer)
              const percentHtml = percentShow ? `<span>占比：${percent}%</span>` : ''
              return `<dd class="tooltop-span"><span style="background-color: ${params[i].color}"></span>${params[i].seriesName}: ${params[i].value} ${unit} ${percentHtml}</dd>`
            })
            let formatHtml = `<h3 class="tooltip-h3">${params[0].name}</h3>`
            formatHtml += tooltips.join('')
            return formatHtml
          }
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: !0,
            position: 'bottom',
            offset: 0,
            data: xAxisData
          }
        ],
        yAxis,
        series,
        grid: { top: 35, left: 16, right: 16, bottom: 34, containLabel: !0 }
      }
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumData))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const numbers = [
          'pv',
          'clickNum',
          'paperUseAmount',
          'amount',
          'newRoleMoney',
          'sumRecharge',
          'sumMoney',
          'downNum',
          'newUserNum',
          'createRoleNum',
          'newRoleNum',
          'payRoleUserNum',
          'timeDiff'
        ]
        const rates = [
          'createRoleRate',
          'payRoleUserRate',
          'newRoleRate1d',
          'newRoleRate',
          'sumRebateRate',
          'twoDayCreateRetain',
          'threeDayCreateRetain',
          'fourDayCreateRetain',
          'fiveDayCreateRetain',
          'sixDayCreateRetain',
          'sevenDayCreateRetain',
          'tenDayCreateRetain',
          'fifteenDayCreateRetain',
          'thirtyDayCreateRetain'
        ]
        // 格式化数据格式
        if (numbers.includes(prop)) sums[index] = toThousands(data[prop])
        else if (rates.includes(prop)) sums[index] = toPercentFixed(data[prop])
        else sums[index] = data[prop]
      })
      return sums
    },
    handleMedia(meta) {
      this.mediaId = meta.id
    },
    handleDatetime(dates) {
      const [start, end] = dates || []
      if (!start || !end) return
      const limitDate = moment(end).subtract(90, 'days')

      if (limitDate.isAfter(start)) {
        this.$Message.warning('日期范围不能超过90天！')
        const newDate = limitDate.format('YYYY-MM-DD')
        this.datetime = [newDate, end]
      }

      if (this.labelIds.length) {
        this.pageIndex = 1
        this.getData()
      }
    },
    setLabelIds(val) {
      setLocal('label_life_cycle', val)
    },
    changeSize(size) {
      this.pageSize = size
      this.tableList = this.calcTableData()
    },
    changePIndex(index) {
      this.pageIndex = index
      this.tableList = this.calcTableData()
    },
    downData() {
      const [beginTime, endTime] = this.datetime || []
      const path = '/api/ptom/media/downMaterialLabelData'
      const url = `${HOST_API}${path}?`

      const params = {
        sessionid: this.$store.state.token,
        platform: this.platform,
        labelIdsStr: this.labelIds.join(','),
        labelGroupIdStr: this.tagGroups.join(','),
        queryType: this.queryType,
        mediaId: this.mediaId
      }

      if (beginTime && endTime) {
        params.beginTime = beginTime
        params.endTime = endTime
      }

      this.order && (params.order = this.order)
      this.sort && (params.sort = this.sort)

      const queryString = new URLSearchParams(params).toString()
      console.log('queryString output: ', queryString)
      window.open(url.concat(queryString))
    },
    proLoadData() {
      const label_session = getLocal('label_life_cycle')
      if (isArray(label_session) && label_session.length) {
        this.labelIds = label_session
      } else this.labelIds = []

      this.getData()

      // 渲染EC对比下拉框
      this.referEc = 'amount'
    }
  },
  data() {
    return {
      show: null,
      pageSize: 15,
      // tableListLoaded作为是否请求数据的标记，表格因为请求数据时间间隔，会导致显示问题，等待数据请求完后再计算表格高度进行表格渲染
      tableListLoaded: false,
      tableHeight: 230,
      selectedGameIds: [], // 保存查询列表已选的游戏组的游戏id，通过结果筛选标签
      queryType: 1, // 统计方式  1 分日  2 汇总
      platform: '0',
      mediaId: '',
      sysTagData: [],
      labelIds: [],
      gameGroups: [], // 游戏组
      tagGroups: [], // 标签组
      // labelList: [], // 标签列表
      columns: [], // 表格字段
      tableList: [], // 表格数据
      listData: [], // 所有数据
      sumData: [], // 统计数据
      dropData: [], // 对比下拉数据
      referEc: '',
      echartsOptions: {},
      datetime: []
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage('MaterLifeCustomColumn', show)
      },
      deep: true
    },
    platform(nVal) {
      this.pageIndex = 1
      this.labelIds.length && this.getData()
    },
    referEc(nVal) {
      this.creatEchart(nVal)
    }
  },
  created() {
    const dropData = JSON.parse(JSON.stringify(columns))
    dropData.shift()
    dropData.shift()
    const beginTime = moment().format('YYYY-MM-DD')
    const endTime = moment().format('YYYY-MM-DD')
    this.datetime = [beginTime, endTime]
    this.dropData = dropData
    const shows = this.getCustomStorage('LabelCustomColumn')
    // 同步本地存储自定义列
    if (shows.length) {
      const local_shows = shows
        .filter((ret) => ret)
        .map((ret) => {
          const item = columns.filter((met) => met.key === ret).pop() || {}
          item.show = false
          return item
        })
      const extend_shows = columns
        .filter((ret) => !shows.includes(ret.key))
        .map((ret) => {
          ret.show = true
          return ret
        })
      this.columns = [...local_shows, ...extend_shows]
    } else {
      this.columns = [...columns]
    }
    this.proLoadData()
    // timeout(300).then(() => {
    //   this.getData()
    // })
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.c-material-lifecycle {
  position: relative;
  padding-top: 10px;

  .c-m-table {
    ::v-deep .ivu-btn:hover {
      background-color: transparent;
    }

    .c-table-list {
      height: 44px;

      .c-pane {
        height: 100%;
      }
    }

    .c-compare-wrap {
      position: relative;
      height: 350px;
      margin-bottom: 12px;
      padding: 0 12px 0;
      background-color: #fff;

      .c-compare-form {
        width: 420px;
        height: 48px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 8px;
      }

      .c-echarts {
        height: calc(100% - 48px);
      }
    }

    .c-show-switch {
      height: 32px;
      display: inline-flex;
      align-items: center;
      padding: 0 10px 0 5px;

      span {
        padding: 0 8px;
      }
    }
  }

  .c-table-page {
    padding: 0 8px;
    margin-top: 7px;
    text-align: right;
  }

  .no-data {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span {
      color: #909399;
      font-size: 14px;
    }
  }
}

::v-deep .summary-type-radio {
  .el-radio-button__inner {
    background: transparent;
    color: $primary-color;
  }
}
</style>
